module.exports = "/packs/images/homepage/activity/tennis_mobile~9b9f5bbcf329790ca3c1aa95fd48a30b.jpg";